import React from 'react';
import blogCover from '../images/blog13.png';
import blogCover2 from '../images/blog14.png';
import OurPartner from '../pages/components/OurPartner';
import SuggestedBlogs from './components/SuggestedBlogs';
import { FaUser, FaCalendarAlt, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { features } from "./components/BlogSection";
import { Link } from "react-router-dom";

const currentIndex = features.findIndex(
    (blog) => blog.link === "/custom-web-app-development-peregrinee"
);

const prevBlog = features[currentIndex - 1];
const nextBlog = features[currentIndex + 1];

function CustomWebAppDevelopmentPeregrinee() {

    const postDate = "March 5, 2026";

    return (
        <>
            {/* BLOG HEADER */}
            <section className="container my-5">

                <div className="text-center mb-4">

                    <h1 className="fw-bold responsive-heading mb-3">
                        <span className="highlight-orange">
                            Peregrinee’s Complete Guide to Custom Web App Development
                        </span>
                    </h1>

                    <p className="mt-3 text-muted fs-5">
                        A comprehensive guide to building scalable, secure, and high-performance
                        custom web applications with Peregrinee.
                    </p>

                    {/* AUTHOR + DATE */}
                    <div className="d-flex justify-content-center align-items-center gap-4 mt-3 text-muted">

                        <span className="d-flex align-items-center gap-2">
                            <FaUser />
                            Posted by <strong>Peregrinee</strong>
                        </span>

                        <span className="d-flex align-items-center gap-2">
                            <FaCalendarAlt />
                            {postDate}
                        </span>

                    </div>

                </div>

            </section>

            {/* HERO IMAGE */}
            <section className="container mb-5">
                <img
                    src={blogCover}
                    alt="Custom Web App Development"
                    className="img-fluid rounded-4 shadow w-100"
                    style={{ maxHeight: "500px", objectFit: "cover" }}
                />
            </section>


            {/* SECTION 1 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6">
                        <img
                            src={blogCover}
                            alt="Custom Web App Development"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />
                    </div>

                    <div className="col-lg-6">

                        <h3 className="fw-bold highlight-orange">
                            What Is Custom Web App Development?
                        </h3>

                        <p>
                            Custom web app development is the process of designing and building web-based
                            applications specifically tailored to a business’s requirements. Unlike
                            off-the-shelf solutions, these applications are built to adapt to unique
                            workflows, ensuring performance, scalability, and security.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Why Businesses Choose Custom Web Applications
                        </h3>

                        <p>
                            Businesses need software that adapts to complex workflows, integrations,
                            and user demands. Custom web apps remove limitations of generic tools,
                            giving full control over features, data, and user experience.
                        </p>

                        <ul className="ps-3">
                            <li>Tailored functionality for unique workflows</li>
                            <li>Scalable architecture for future growth</li>
                            <li>Enhanced security and data control</li>
                            <li>Seamless integration with existing systems</li>
                        </ul>

                    </div>

                </div>

            </section>


            {/* SECTION 2 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6 order-lg-1 order-2">

                        <h3 className="fw-bold highlight-orange">
                            Peregrinee’s Approach & Solutions
                        </h3>

                        <p>
                            Peregrinee follows a strategic, user-focused approach to web app
                            development. From discovery and UI/UX design to development,
                            testing, and deployment, every application is built for reliability,
                            performance, and long-term success.
                        </p>

                        <p>
                            Our custom web applications are cloud-ready, secure, and maintainable.
                            Whether launching a new product or modernizing an existing system,
                            Peregrinee delivers solutions that grow with your business.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Final Thoughts
                        </h3>

                        <p>
                            Investing in custom web app development means efficiency,
                            scalability, and a competitive edge. Peregrinee combines
                            technical expertise with business insight to build applications
                            that drive real results.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold mt-3"
                            style={{ width: "fit-content" }}
                        >
                            Build Your Custom Web App with Peregrinee
                        </a>

                    </div>

                    <div className="col-lg-6 order-lg-2 order-1">
                        <img
                            src={blogCover2}
                            alt="Peregrinee Approach"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />
                    </div>

                </div>

            </section>


            {/* BLOG NAVIGATION */}
            <section className="container my-5">

                <div className="row">

                    {/* PREVIOUS BLOG */}

                    {prevBlog && (
                        <div className="col-md-6 mb-3">

                            <Link
                                to={prevBlog.link}
                                className="d-flex align-items-center gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <FaArrowLeft />

                                <div>
                                    <small className="text-muted">Previous Blog</small>
                                    <h6 className="mb-0 fw-bold">{prevBlog.title}</h6>
                                </div>

                            </Link>

                        </div>
                    )}

                    {/* NEXT BLOG */}

                    {nextBlog && (
                        <div className="col-md-6 mb-3 text-md-end">

                            <Link
                                to={nextBlog.link}
                                className="d-flex align-items-center justify-content-md-end gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <div>
                                    <small className="text-muted">Next Blog</small>
                                    <h6 className="mb-0 fw-bold">{nextBlog.title}</h6>
                                </div>

                                <FaArrowRight />

                            </Link>

                        </div>
                    )}

                </div>

            </section>


            {/* SUGGESTED BLOGS */}
            <SuggestedBlogs />

            <OurPartner />

        </>
    );
}

export default CustomWebAppDevelopmentPeregrinee;